module.exports = __webpack_public_path__ + "media/images/logo/logo_keirin_basic-00506f112dd2ba6a0b54b720067a6a38.svg";